import { useEffect, useState } from "react";

export type UseDelayedValueArgs<T> = {
  value: T;
  delay: number;
};

export type UseDelayedValueResult<T> = T;

export const useDelayedValue = <T,>(
  args: UseDelayedValueArgs<T>,
): UseDelayedValueResult<T> => {
  const { value, delay } = args;
  const [delayedValue, setDelayedValue] = useState(value);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDelayedValue(value);
    }, delay);
    return () => {
      clearTimeout(timeout);
    };
  }, [value, delay]);
  return delayedValue;
};
